// breakpoint para lg+
const breakpointNavbar = window.matchMedia( '(min-width:992px)' );
if ( breakpointNavbar.matches === true ) {
    document.addEventListener("DOMContentLoaded", function () {
        window.onscroll = function () {
            showNavbar()
        };

        const navbar = document.querySelector(".navbar.fixed-top");
        const sticky = navbar.offsetTop + 250;

        // Variáveis do campo de busca
        const search_form = document.querySelector("#search-form");
        const search_button = document.querySelector(".search-box");

        const search_form_fixed = document.querySelector("#search-form-fixed");
        const search_button_fixed = document.querySelector(".search-box-fixed");

        // Variáveis do menu
        const menu_button = document.querySelector("#menuToggle");
        const navbar_menu = document.querySelector("#navbarNavPrimary");

        const menu_button_fixed = document.querySelector("#menuToggleFixed");
        const navbar_menu_fixed = document.querySelector("#navbarNavPrimaryFixed");

        function showNavbar() {
            if (window.pageYOffset >= sticky) {
                navbar.classList.remove("hide");
                if (navbar_menu.classList.contains('show')) {
                    menu_button.click(); // Abre menu ao esconder navbar fixo no topo.
                    menu_button_fixed.click(); // Fecha menu fixo.
                }
            } else {
                navbar.classList.add("hide");
                if (search_form_fixed.classList.contains('show')) {
                    search_button_fixed.click(); // Fecha campo de busca ao esconder navbar fixada no topo.
                }
                if (navbar_menu_fixed.classList.contains('show')) {
                    menu_button.click(); // Fecha menu ao exibir navbar fixo no topo.
                    menu_button_fixed.click(); // Abre menu fixo.
                }
            }
        }

        search_button.addEventListener('click', function () {
            setTimeout(() => {
                search_form.querySelector('input').focus();
            }, 350);
        });

        search_button_fixed.addEventListener('click', function () {
            setTimeout(() => {
                search_form_fixed.querySelector('input').focus();
            }, 350);
        });
    });
}
